// @ts-nocheck
import React from "react";
import {t} from 'ttag';
import {Box, IconButton} from "@mui/material";
import {Check, Close, DeleteOutlined, EditOutlined} from "@mui/icons-material";

export const columns = ({editHandler, removeHandler}) => [
  {
    field: 'description',
    headerName: t`Description`,
    editable: false,
    sortable: false,
    disableColumnMenu: true,
    flex: 1
  },
  {
    field: 'active',
    headerName: t`Active`,
    type: 'boolean',
    editable: false,
    sortable: false,
    disableColumnMenu: true,
    flex: 1,
    renderCell: ({ row }) => (
      !row.disabled ? <Check color={'success'}/> : <Close color={'error'}/>
    )
  },
  {
    field: 'actions',
    headerName: t`Actions`,
    type: 'number',
    flex: 1,
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      return (
        <Box>
          <IconButton onClick={() => editHandler(params.row)} color={'secondary'} aria-label='edit'>
            <EditOutlined fontSize='inherit' />
          </IconButton>
          <IconButton onClick={() => removeHandler(params.row)} color={'secondary'} aria-label='delete'>
            <DeleteOutlined fontSize='inherit'/>
          </IconButton>
        </Box>
      )
    }
  },
];

export const helper = {
  columns
};

export default helper;
